import React, { useEffect, useState } from 'react';
import { F } from '../../config/styles';
import { subscribeCropJobs, dismissCropJob } from '../../utils/cropJobs';

const STAGE = { queued: 'Waiting…', loading: 'Loading video tools…', encoding: 'Processing', uploading: 'Uploading…', done: 'Done', error: 'Failed' };

// Corner card for background video crops: collapses to a single pill, and only exists while
// there's something to show.
export function CropJobsTray() {
  const [jobs, setJobs] = useState([]);
  const [collapsed, setCollapsed] = useState(false);
  useEffect(() => subscribeCropJobs(setJobs), []);
  if (!jobs.length) return null;

  const active = jobs.filter(j => j.status !== 'done' && j.status !== 'error');
  const failed = jobs.filter(j => j.status === 'error').length;
  const current = jobs.find(j => j.status === 'encoding');
  const summary = active.length
    ? `Cropping ${active.length} video${active.length === 1 ? '' : 's'}${current ? ` · ${Math.round(current.progress * 100)}%` : ''}`
    : failed ? `${failed} video crop${failed === 1 ? '' : 's'} failed` : 'Video crops done';

  return (
    <div style={{ position: 'fixed', right: 20, bottom: 20, zIndex: 1100, width: collapsed ? 'auto' : 320, background: '#1a1a1a', color: '#fff', borderRadius: 12, boxShadow: '0 6px 24px rgba(0,0,0,0.3)', fontFamily: F.body, fontSize: 12, overflow: 'hidden' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '10px 14px', cursor: 'pointer' }} onClick={() => setCollapsed(c => !c)}>
        {active.length > 0 && <div style={{ width: 12, height: 12, border: '2px solid rgba(255,255,255,0.3)', borderTopColor: '#fff', borderRadius: '50%', animation: 'cropspin 0.8s linear infinite', flexShrink: 0 }} />}
        <span style={{ flex: 1, whiteSpace: 'nowrap' }}>{summary}</span>
        <span style={{ opacity: 0.6 }}>{collapsed ? '▴' : '▾'}</span>
        {!active.length && (
          <button onClick={e => { e.stopPropagation(); jobs.forEach(j => dismissCropJob(j.id)); }}
            style={{ background: 'none', border: 'none', color: '#fff', opacity: 0.7, cursor: 'pointer', fontSize: 14, padding: 0 }}>×</button>
        )}
      </div>
      {!collapsed && (
        <div style={{ maxHeight: 240, overflow: 'auto', borderTop: '1px solid rgba(255,255,255,0.12)' }}>
          {jobs.map(j => (
            <div key={j.id} style={{ padding: '8px 14px', borderBottom: '1px solid rgba(255,255,255,0.06)' }}>
              <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                <span style={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{j.label}</span>
                <span style={{ opacity: 0.7, color: j.status === 'error' ? '#fca5a5' : j.status === 'done' ? '#86efac' : '#fff', whiteSpace: 'nowrap' }}>
                  {j.status === 'encoding' ? `${STAGE.encoding} ${Math.round(j.progress * 100)}%` : STAGE[j.status]}
                </span>
                {(j.status === 'done' || j.status === 'error') && (
                  <button onClick={() => dismissCropJob(j.id)} style={{ background: 'none', border: 'none', color: '#fff', opacity: 0.5, cursor: 'pointer', padding: 0 }}>×</button>
                )}
              </div>
              {j.status === 'encoding' && (
                <div style={{ height: 3, background: 'rgba(255,255,255,0.15)', borderRadius: 2, marginTop: 6 }}>
                  <div style={{ width: `${j.progress * 100}%`, height: '100%', background: '#fff', borderRadius: 2, transition: 'width 0.3s' }} />
                </div>
              )}
              {j.error && <div style={{ color: '#fca5a5', marginTop: 4, whiteSpace: 'normal' }}>{j.error}</div>}
            </div>
          ))}
          <div style={{ padding: '8px 14px', opacity: 0.55 }}>Keep this tab open until they finish — you can carry on working.</div>
        </div>
      )}
      <style>{'@keyframes cropspin { to { transform: rotate(360deg); } }'}</style>
    </div>
  );
}
